export enum WorkplaceRulesQueryKeys {
  GetWorkplaceRules = 'GetWorkplaceRules',
}
